import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-scroll';
import Tilt from 'react-parallax-tilt';
import { FaArrowDown } from 'react-icons/fa';
import logo from '../assets/Masriq_Logo.png';

const Hero = () => {
  return (
    <section
      id="hero"
      className="relative h-screen w-full overflow-hidden bg-[#0A0A23] text-white"
    >
      <motion.div
        className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6"
        initial={{ opacity: 0, y: 60 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2 }}
      >
        {/* 3D Tilt Logo */}
        <Tilt
          tiltMaxAngleX={20}
          tiltMaxAngleY={20}
          perspective={1000}
          transitionSpeed={1000}
          scale={1.05}
          gyroscope={true}
        >
          <motion.img
            src={logo}
            alt="MASRIQ NextTech Solutions Logo – AI & Software Company in Bangalore"
            className="h-40 w-40 sm:h-44 sm:w-44 md:h-52 md:w-52 mb-6 object-contain drop-shadow-[0_0_10px_rgba(34,211,238,0.5)]"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.2 }}
            loading='lazy'
          />
        </Tilt>

        {/* Tagline */}
        <h1 className="mt-4 max-w-2xl text-xl sm:text-2xl font-medium text-white/90">
          We don’t just build tech. We{' '}
          <span className="text-cyan-400 font-semibold">think it!</span>.
        </h1>

        <div className="mt-6 flex flex-col sm:flex-row gap-4 justify-center">
          {/* Primary CTA */}
          <Link
            to="services"
            spy={true}
            smooth={true}
            offset={-70} // Adjust if you have a fixed navbar
            duration={800}
            className="px-8 py-3 bg-gradient-to-r from-cyan-400 to-blue-500 text-black font-semibold rounded-lg shadow-md transition-all duration-500 hover:shadow-xl hover:from-cyan-500 hover:to-blue-600 hover:scale-105 hover:ring-2 hover:ring-cyan-300 hover:ring-offset-2 flex items-center gap-2 cursor-pointer"
          >
            Explore Services
            <span className="inline-block animate-pulse">→</span>
          </Link>

          {/* Secondary CTA */}
          <Link
            to="quote"
            spy={true}
            smooth={true}
            offset={-70}
            duration={800}
            className="px-8 py-3 border-2 border-cyan-400 text-cyan-400 font-semibold rounded-lg transition-all duration-500 hover:bg-cyan-400 hover:text-black hover:shadow-md hover:ring-2 hover:ring-cyan-300 hover:ring-offset-2 flex items-center gap-2 cursor-pointer"
          >
            Get a Quote
            <span className="inline-block animate-bounce">✨</span>
          </Link>
        </div>
        
        {/* MODIFIED SECTION STARTS HERE */}
        <div className="mt-6 flex justify-center">
          <a
            href="https://portfolio.masriq.tech"
            className="group flex items-center gap-2 text-cyan-400/90 font-medium tracking-wide transition-all duration-300 hover:text-cyan-300 hover:drop-shadow-[0_0_10px_rgba(34,211,238,0.6)]"
          >
            <span>Visit Company's Portfolio</span>
            <span className="inline-block transition-transform duration-300 ease-in-out group-hover:translate-x-1.5">→</span>
          </a>
        </div>
        {/* MODIFIED SECTION ENDS HERE */}

        {/* Scroll Down Indicator */}
        <motion.div
          className="absolute bottom-8 flex flex-col items-center gap-2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5, duration: 1 }}
        >
          <p className="text-white/70 text-sm sm:text-base max-w-xs text-center px-4">
            Get connected to future to reshape the way of living through AI
          </p>

          <Link
            to="connect"
            spy={true}
            smooth={true}
            offset={-70}
            duration={800}
            className="cursor-pointer"
          >
            <motion.div
              animate={{ y: [0, 10, 0] }}
              transition={{ repeat: Infinity, duration: 1.5 }}
            >
              <FaArrowDown className="text-cyan-400 text-2xl sm:text-3xl drop-shadow-[0_0_10px_rgba(34,211,238,0.6)] transition hover:scale-110" aria-label='Arrow pointing down to scroll to next section'/>
            </motion.div>
          </Link>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;